import { SCol, SRow } from '@avalara/skylab-sdk/react';
import type React from 'react';

import Subtext from './order-item-subtext';

type Props = {
  name: string | null | undefined;
  price: string;
  strikethrough?: boolean;
  subtext?: string;
  nameStyle?: React.CSSProperties;
  priceStyle?: React.CSSProperties;
  nameSuffix?: React.ReactNode;
};

const OrderItem = ({ name, price, strikethrough, subtext, nameStyle, priceStyle, nameSuffix }: Props) => (
  <SRow className='pad-top-xs'>
    <SCol span='8' className={subtext ? 'pad-bottom-none' : undefined} style={nameStyle}>
      <span>
        {name}
        {nameSuffix}
      </span>
      {subtext && (
        <span>
          <Subtext text={subtext} />
        </span>
      )}
    </SCol>
    <SCol
      data-ref='buy.order-summary.price'
      span='4'
      style={priceStyle}
      className={`text-right${strikethrough ? ' text-strikethrough' : ''}`}
    >
      <span>{price}</span>
    </SCol>
  </SRow>
);
export default OrderItem;
